module.exports = __webpack_public_path__ + "68fa14f24f68055c6f1d5cb742409cfb.png";